import { render, staticRenderFns } from "./WidgetCarouselProductEditor.vue?vue&type=template&id=393d6d13&scoped=true"
import script from "./WidgetCarouselProductEditor.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselProductEditor.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselProductEditor.vue?vue&type=style&index=0&id=393d6d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d6d13",
  null
  
)

export default component.exports